import React, { FunctionComponent } from 'react';
import { Box, Text } from 'rebass/styled-components';
import { ElidableText } from '..';
import {
  parseTitle, parseName, ConfigEditorType,
} from './util';
import { InputShape, InputV2 } from '../v2/input';
import EditorDropdown from './editor-dropdown';

export interface IEditorFieldProps {
  isEditing: boolean;
  value: any;
  selectItem: (it: any) => void;
  items: Array<any>;
  actionType?: ConfigEditorType;
  noFreeText?: boolean;
  placeholder?: string;
  isErrored?: boolean;
  hasTransfer?: boolean;
}

const EditorField: FunctionComponent<IEditorFieldProps> = ({
  items,
  value,
  isEditing,
  selectItem,
  actionType = undefined,
  noFreeText = false,
  placeholder = 'Enter a value',
  isErrored = false,
  hasTransfer = undefined,
}: IEditorFieldProps) => {
  const hasItems = items?.length > 0;
  const title = parseTitle(value, actionType);
  const name = parseName(value, actionType, placeholder, hasItems, isEditing) || '';

  if (isEditing) {
    if (hasItems) {
      return (
        <Box data-testid="editor-dropdown" minWidth={80}>
          <EditorDropdown
            value={value}
            onChange={selectItem}
            items={items}
            actionType={actionType}
            noFreeText={noFreeText}
            hasTransfer={hasTransfer}
            placeholder={placeholder}
            isErrored={isErrored}
          />
        </Box>
      );
    }

    if (noFreeText) {
      return (
        <Box data-testid="editor-dropdown" title={title} height="100%">
          <InputV2
            placeholder={name}
            value={value}
            onChange={() => {}}
            shape={InputShape.SQUARE}
            disabled
            isErrored
          />
        </Box>
      );
    }
    return (
      <Box data-testid="editor-dropdown" title={title} height="100%">
        <InputV2
          placeholder={placeholder}
          value={value}
          onChange={(ev) => selectItem(ev.target.value)}
          shape={InputShape.SQUARE}
          isErrored={isErrored}
        />
      </Box>
    );
  }

  return (
    <Box data-testid="editor-dropdown" title={title} p={2}>
      <Text variant="primary">
        <ElidableText lineCount={1} text={name} />
      </Text>
    </Box>
  );
};

export default EditorField;
